export const questions = [
  {
    key: "movePlan",
    text: "Când plănuiești să te muți?",
    label: "Mutați planul",
    suggestions: [
      "Cât mai repede posibil",
      "În următoarele 3 luni",
      "Mai târziu de 3 luni",
    ],
    check: 3,
  },
  {
    key: "budgetPricing",
    text: "Care este bugetul tău lunar?",
    label: "Prețuri la buget",
    suggestions: ["Sub €2,000", "€2,000 - €5,000", "Peste €5,000"],
    check: 4,
  },
  {
    key: "preferredLocation",
    text: "Locație preferată:",
    label: "Locație preferată",
    suggestions: [
      "District sau zonă specifică (vă rugăm să specificați)",
      "Deschis la sugestii",
    ],
    check: 5,
  },
  {
    key: "officeType",
    text: "Tip de birou:",
    label: "Tip birou",
    suggestions: [
      "Apartament (parter sau tip apartament)",
      "Clădire de birouri (etaje dedicate sau turn de afaceri)",
      "Nicio preferință",
    ],
    check: 6,
  },
  {
    key: "leaseDuration",
    text: "Durata contractului de închiriere:",
    label: "Durata contractului de închiriere",
    suggestions: [
      "Pe termen scurt (până la 1 an)",
      "Pe termen mediu (1–3 ani)",
      "Pe termen lung (3+ ani)",
    ],
    check: 7,
  },
  {
    key: "parking",
    text: "Ai nevoie de parcare?",
    label: "Parcare",
    suggestions: [
      "Nu este nevoie de parcare",
      "1–2 spații",
      "3 sau mai multe spații",
    ],
    check: 10,
  },
  {
    key: "accessibilityTransport",
    text: "Cât de important este accesul la transportul public?",
    label: "Acces transport",
    suggestions: [],
    check: 11,
  },
];
